import { deepEqual } from "./deep_equal";
import dayjs from "./dayjs";
import { DatePivotParams } from "../entities/date_pivot_params";

export const isDatePivotParamsEqual = (
  a: DatePivotParams,
  b: DatePivotParams | undefined
) => {
  let eq = !!b;
  if (b) {
    eq = eq && a.dateHierarchy === b.dateHierarchy;
    if (a.measure) {
      eq = eq && a.measure === b.measure;
    }
    // Compare segments arrays - they must be exactly equal (same elements, same order)
    // Use deepEqual to handle array comparison correctly
    eq = eq && deepEqual(a.segments, b.segments);
    eq = eq && dayjs(a.minDate).isSame(dayjs(b.minDate), "day");
    eq = eq && dayjs(a.maxDate).isSame(dayjs(b.maxDate), "day");
    eq = eq && deepEqual(a.filters, b.filters);
    eq = eq && deepEqual(a.postFilters, b.postFilters);
  }
  return eq;
};
